import { Alert, Button, Space, Tag, Typography } from 'antd';
import {
  CheckCircleOutlined,
  EditOutlined,
  UserOutlined
} from '@ant-design/icons';

import { ProducerDTO } from '../../types/data/producer-management.type';
import React from 'react';

const { Text } = Typography;

interface ActiveProducerBannerProps {
  activeProducer: ProducerDTO | null;
  onEdit?: (producer: ProducerDTO) => void;
}

const ActiveProducerBanner: React.FC<ActiveProducerBannerProps> = ({
  activeProducer,
  onEdit
}) => {
  if (!activeProducer) {
    return (
      <Alert
        message='No Active Producer'
        description='Please activate a producer to enable E-App submissions.'
        type='warning'
        showIcon
        style={{ marginBottom: 16 }}
      />
    );
  }

  return (
    <Alert
      message={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
          <Space>
            <CheckCircleOutlined style={{ color: '#52c41a' }} />
            <Text strong>Active Producer for E-App Submissions</Text>
          </Space>
          {onEdit && (
            <Button
              type='primary'
              size='small'
              icon={<EditOutlined />}
              onClick={() => onEdit(activeProducer)}>
              Edit Producer
            </Button>
          )}
        </div>
      }
      description={
        <Space direction='vertical' size='small' style={{ width: '100%' }}>
          <Space>
            <UserOutlined />
            <Text strong>{activeProducer.name}</Text>
            <Text type='secondary'>NPN: {activeProducer.npnNumber}</Text>
          </Space>
          <Space wrap>
            <Text type='secondary'>Carriers Contracted:</Text>
            {activeProducer.carrierMappings?.length > 0 ? (
              activeProducer.carrierMappings.map((mapping, index) => (
                <Tag key={index} color='blue'>
                  {mapping.carrierName} ({mapping.carrierNaic})
                  {mapping.agentId && ` - Agent ID: ${mapping.agentId}`}
                </Tag>
              ))
            ) : (
              <Text type='secondary' italic>
                No carrier contracts configured
              </Text>
            )}
          </Space>
        </Space>
      }
      type='success'
      showIcon
      style={{
        marginBottom: 16,
        border: '2px solid #b7eb8f',
        backgroundColor: '#f6ffed'
      }}
    />
  );
};

export default ActiveProducerBanner;
